/**
 * Generated by orval 🍺
 * Do not edit manually.
 * Internal API
 * OpenAPI spec version: v1
 */
import {
  useQuery
} from '@tanstack/vue-query';
import type {
  DataTag,
  QueryClient,
  QueryFunction,
  QueryKey,
  UseQueryOptions,
  UseQueryReturnType
} from '@tanstack/vue-query';

import {
  unref
} from 'vue';

import type {
  PaginatedVideoRecorderFiles
} from '../../models';

import { axiosClient } from '../../../internalAxiosClient.ts';
import type { ErrorType } from '../../../internalAxiosClient.ts';




/**
 * @summary List of Files
 */
export const listVideoRecorderFiles = (

 signal?: AbortSignal
) => {


      return axiosClient<PaginatedVideoRecorderFiles>(
      {url: `/video_recorder/files`, method: 'GET', signal
    },
      );
    }




export const getListVideoRecorderFilesQueryKey = () => {
    return [
    'video_recorder','files'
    ] as const;
    }


export const getListVideoRecorderFilesQueryOptions = <TData = Awaited<ReturnType<typeof listVideoRecorderFiles>>, TError = ErrorType<void>>( options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof listVideoRecorderFiles>>, TError, TData>>, }
) => {

const {query: queryOptions} = options ?? {};

  const queryKey =  getListVideoRecorderFilesQueryKey();



    const queryFn: QueryFunction<Awaited<ReturnType<typeof listVideoRecorderFiles>>> = ({ signal }) => listVideoRecorderFiles(signal);





   return  { queryKey, queryFn, ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof listVideoRecorderFiles>>, TError, TData>
}

export type ListVideoRecorderFilesQueryResult = NonNullable<Awaited<ReturnType<typeof listVideoRecorderFiles>>>
export type ListVideoRecorderFilesQueryError = ErrorType<void>


/**
 * @summary List of Files
 */

export function useListVideoRecorderFiles<TData = Awaited<ReturnType<typeof listVideoRecorderFiles>>, TError = ErrorType<void>>(
  options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof listVideoRecorderFiles>>, TError, TData>>, }
 , queryClient?: QueryClient
 ): UseQueryReturnType<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {

  const queryOptions = getListVideoRecorderFilesQueryOptions(options)

  const query = useQuery(queryOptions, queryClient) as UseQueryReturnType<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

  query.queryKey = unref(queryOptions).queryKey as DataTag<QueryKey, TData, TError>;

  return query;
}






